<template>
  <div v-if="$vuetify.breakpoint.mdAndUp">
    <tk-btn
      aria-label="Account"
      v-if="$auth.currentUser"
      flat
      icon
      small
      :to="{ name:'profile.account' }"
    >
      <v-icon size="20">fas fa-user</v-icon>
    </tk-btn>
    <tk-btn aria-label="Login" v-else icon small @click="$app.loginDialog = true">
      <v-icon size="20">far fa-user</v-icon>
    </tk-btn>
  </div>
  <div v-else>
    <tk-btn aria-label="Searh" flat icon small @click="onSearchClicked">
      <v-icon size="20">fas fa-search</v-icon>
    </tk-btn>
  </div>
</template>

<script>
import { MOBILE_SEARCH_BUTTON_EVENT } from "../../AppKeys";

export default {
  methods: {
    logout() {
      this.$auth.logout();
      this.$router.replace({ name: "home" });
    },

    async onSearchClicked() {
      console.log("onSearchCLicked", this.$route.name);
      if (this.$route.name !== "search") {
        await this.$router.push({ name: "search", query: { page: 1 } });
      }
      this.$root.$emit(MOBILE_SEARCH_BUTTON_EVENT);
    },
  },
};
</script>

<style scoped>
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent;
}
</style>
